import * as React from 'react';

const SvgChat = (props) => (
  <svg
    width={42}
    height={42}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.688 14c0-.725.587-1.313 1.312-1.313h7a1.312 1.312 0 1 1 0 2.626h-7A1.312 1.312 0 0 1 12.687 14ZM12.688 21c0-.725.587-1.313 1.312-1.313h14a1.312 1.312 0 1 1 0 2.625H14A1.312 1.312 0 0 1 12.687 21Z'
      fill='#858585'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.441 2.188h7.118c2.4 0 4.282 0 5.795.123 1.54.126 2.813.386 3.964.973a10.063 10.063 0 0 1 4.398 4.398c.587 1.151.847 2.424.973 3.964.123 1.513.123 3.395.123 5.795v2.389c0 2.71.001 4.363-.406 5.751a10.063 10.063 0 0 1-6.825 6.825c-1.388.407-3.042.407-5.752.407h-1.322a7.437 7.437 0 0 0-4.237 1.357l-.086.061-4.569 3.264c-2.633 1.88-6.092-.835-4.89-3.84a.615.615 0 0 0-.572-.843H10.1A7.913 7.913 0 0 1 2.188 24.9V17.44c0-2.4 0-4.282.123-5.795.126-1.54.386-2.813.973-3.964a10.062 10.062 0 0 1 4.398-4.398c1.151-.587 2.424-.847 3.964-.973 1.513-.124 3.395-.124 5.795-.123Zm-5.581 2.74c-1.378.112-2.267.328-2.987.695a7.437 7.437 0 0 0-3.25 3.25c-.367.72-.583 1.609-.696 2.987-.113 1.393-.114 3.168-.114 5.64v7.4a5.288 5.288 0 0 0 5.287 5.288h1.053c2.292 0 3.86 2.314 3.008 4.442-.227.57.429 1.086.928.729l4.57-3.264.099-.07a10.063 10.063 0 0 1 5.732-1.837H26.572c3.049 0 4.291-.014 5.27-.301a7.437 7.437 0 0 0 5.045-5.044c.287-.98.3-2.222.3-5.27V17.5c0-2.472 0-4.247-.114-5.64-.113-1.378-.33-2.267-.696-2.987a7.438 7.438 0 0 0-3.25-3.25c-.72-.367-1.609-.583-2.987-.696-1.393-.113-3.168-.114-5.64-.114h-7c-2.472 0-4.247 0-5.64.114Z'
      fill='#858585'
    />
  </svg>
);

export default SvgChat;
